import { css } from "lit";
export default css `
    
    strong {
        display: block;
        margin-bottom: var(--global-space);
    }
    
    sl-alert::part(base) {
        font: var(--font-stack);
        color: var(--font-color);
        border: none;
        border-radius: 0;
        background-color: var(--error-color-verylowalpha);
    }
   
    sl-alert.error::part(base) {
        border: 1px dashed var(--error-color);
        background-color: var(--terminal-background);
    }
    sl-alert.error::part(icon) {
        color: var(--error-color);
        font-size: 1.5rem;
    }
    sl-alert.error > strong {
        color: var(--error-color);
        font: 1.2rem var(--font-stack-bold);
    }

    sl-alert.warning::part(icon) {
        color: var(--warn-300);
        font-size: 1.5rem;
    }
    sl-alert.warning::part(base) {
        border: 1px dashed var(--warn-200);
        background-color: var(--terminal-background);
    }
 
    sl-alert.warning > strong {
        color: var(--warn-200);
        font: 1.2rem var(--font-stack-bold);
    }
    
    sl-alert.info::part(base) {
        border: 1px dashed var(--primary-color);
        background-color: var(--terminal-background);
    }
    sl-alert.info::part(icon) {
        color: var(--primary-color);
        font-size: 1.5rem;
    }
    sl-alert.info > strong {
        font: 1.2rem var(--font-stack-bold);
        color: var(--primary-color);
    }
    
    sl-alert.success::part(base) {
        border: 1px dashed var(--terminal-text);
        background-color: var(--terminal-background);
    }
    sl-alert.success::part(icon) {
        color: var(--terminal-text);
        font-size: 1.5rem;
    }
    sl-alert.success > strong {
        font: 1.2rem var(--font-stack-bold);
        color: var(--terminal-text);
    }

    sl-alert.question::part(base) {
        border: 1px dashed var(--secondary-color);
        background-color: var(--terminal-background);
    }
    sl-alert.question::part(icon) {
        color: var(--secondary-color);
        font-size: 1.5rem;
    }
    sl-alert.question > strong {
        font: 1.2rem var(--font-stack-bold);
        color: var(--secondary-color);
    }
    

    sl-alert.context::part(base) {
        border: 1px dashed var(--code-border);
        background-color: var(--terminal-background);
    }
    sl-alert.context::part(icon) {
        color: var(--font-color);
        font-size: 1.5rem;
    }
    sl-alert.context > strong {
        font: 1.2rem var(--font-stack-bold);
        color: var(--font-color);
    }
    
    sl-alert::part(message) {
        font: var(--font-stack);
        padding-top: var(--global-padding);
        padding-bottom: var(--global-padding);
    }

`;
